<!-- Empty message for tab kaza -> story -> owner -->
<app-simple-empty-result
  *ngIf="!noEmptyMsg && isProKaza == false && postsList && postsList.length===0 && requestDoneOnce && !postLoading && kazaOfLoggedUser && !emptyMessage"
>
  <div class="kz-kaza-recit--empty">
    <div>
      <h2 i18n="@@kaza.tabs.story.empty.title">Your project’s story</h2>
      <p i18n="@@kaza.tabs.story.empty.text">Have you just purchased your land? Just signed the contract? Or maybe your adventure is already under way... Show us your project and tell us all about your house!</p>
      <a [routerLink]="['', {outlets: {modal: ['lg', 'publish']}}]" kzButton buttonStyle="flat"><span i18n="@@kaza.tabs.story.publish.cta">Present my project</span></a>
    </div>
    <app-picture-source [imgSrc]="'/assets/images/kaza/empty-story.svg'" [alt]="''"
                        [width]="501" [height]="221"
                        [presets]="'w500' | imgPreset" [useLazyLoad]="false" [useWebp]="false"
                        class="kz-profilv2--home-empty-activity"
    ></app-picture-source>
  </div>
</app-simple-empty-result>

<app-empty-result
        *ngIf="requestType !== 'favorites' && !noEmptyMsg && isProKaza == false && postsList && postsList.length===0 && requestDoneOnce && !postLoading&& !kazaOfLoggedUser && !emptyMessage"
>
    <span i18n="@@kaza.tabs.notAuthor.story.empty">No content to display</span>
    <span *ngIf="emptyMessage">{{emptyMessage}}</span>
</app-empty-result>

<!-- Empty message for Favorites -->
<app-simple-empty-result *ngIf="requestType === 'favorites' && !noEmptyMsg && isProKaza == false && postsList && postsList.length===0 && requestDoneOnce && !postLoading&& !kazaOfLoggedUser && !emptyMessage">
  <div class="kz-kaza-recit--empty">
    <div>
      <h2 i18n="@@kaza.tabs.favorites.posts.empty.title">Your favourites on Kozikaza</h2>
      <p i18n="@@kaza.tabs.favorites.posts.empty.text">Has a post caught your eye on Kazacafé? Want to save a tutorial or a photo posted by another member? All of your favourites will be saved here - as well as the bookmark that can be seen on all posts</p>
      <a [routerLink]="['/kazacafe'] | localize" kzButton buttonStyle="flat"><span i18n="@@kaza.tabs.favorites.posts.empty.cta">Favourite my first post</span></a>
    </div>
    <app-picture-source [imgSrc]="'/assets/images/kaza/empty-favoris.svg'"
                        [width]="501" [height]="221"
                        [presets]="'w500' | imgPreset" [useLazyLoad]="false" [useWebp]="false"
    ></app-picture-source>
  </div>
</app-simple-empty-result>

<!-- Empty message for tab pro -> activity -> owner -->
<app-visual-empty-result
        *ngIf="!noEmptyMsg && isProKaza == true && postsList && postsList.length===0 && requestDoneOnce && !postLoading" [showVisuel]="showEmptyVisuel"
        [showVisuel]="false">
  <div class="kz-grid" *ngIf="!emptyMessage">
    <div class="kz-grid-column kz-grid-column-text">
      <ng-container *ngIf="kazaOfLoggedUser" >
        <h2 i18n="@@pro.story.owner.empty">Boost your activity !</h2>
        <p i18n="@@pro.story.owner.empty2">Present your latest achievements to Kozikaza community</p>
        <a [routerLink]="['', {outlets: {modal: ['lg', 'publish']}}]" appGtmTrack="add_publish_pro"
           kzButton buttonStyle="flat" buttonContext="decorator"><span i18n="@@pro.story.owner.publish.cta">Publish</span></a>
      </ng-container>
      <h2 *ngIf="!kazaOfLoggedUser" i18n="@@pro.story.empty">No post to display</h2>
    </div>
    <div class="kz-grid-column kz-grid-column-image">
      <app-picture-source [imgSrc]="'/assets/images/pro/empty/empty-activity.svg'" [alt]="''"
                          [width]="501" [height]="221"
                          [presets]="'w500' | imgPreset" [useLazyLoad]="false" [useWebp]="false"
                          class="kz-profilv2--home-empty-activity"
      ></app-picture-source>
    </div>
  </div>
  <span *ngIf="emptyMessage">{{emptyMessage}}</span>
</app-visual-empty-result>

<ng-container *ngIf="requestType !== 'favorites'">
  <div class="kz-kaza--options"
       *ngIf="((postsList && postsList.length > 0) || (activeFilters && activeFilters.length != 0)) && requestDoneOnce && !postLoading && (showOptionOrder || showOptionFilter)">
    <div class="kz-kaza--options-container">
      <button *ngIf="kazaOfLoggedUser" [routerLink]="['../memories'] | localize" fragment="kaza_menu"
              [queryParams]="{noredirect: true}" kzButton buttonSize="small">
      <span>
        <kz-icons name="memories_monochrome"></kz-icons> <span i18n="@@kaza.tabs.memories.button">My memories <span
        *ngIf="nbMemories > 0" kzBadge badgeType="green">{{ nbMemories }}</span></span>
      </span>
      </button>

      <app-flux-options-filter
        *ngIf="showOptionFilter && kaza"
        (filtersChanged)="redirect()"
        [activeKaza]="kaza"
      ></app-flux-options-filter>
    </div>
    <div class="screen-btn" *ngIf="kazaOfLoggedUser">
      <div class="d-flex justify-content-center screen-shot-box">
        <button type="button" kzButton buttonSize="small" (click)="downloadPictures()" buttonContext="default" buttonStyle="default" [disabled]="isDownloading">
          <span *ngIf="!isDownloading">Télécharger l'ensemble de mes photos</span>
          <span *ngIf="isDownloading">
            <div class="spinner-box">
              <span class="download-spinner"></span> <span>Téléchargement en cours</span>
            </div>
          </span>
        </button>
      </div>
    <div class="d-flex justify-content-center screen-shot-box">
      <button type="button" kzButton buttonSize="small" (click)="downloadScreenShot()" buttonContext="default"  buttonStyle="default">
        <span *ngIf="!screenIsDownloading">Sauvegarder le contenu de ma kaza (.PDF)</span>
        <span *ngIf="screenIsDownloading">
          <div class="spinner-box">
            <span class="download-spinner"></span> <span>Téléchargement en cours</span>
          </div>
        </span>
      </button>
      <kz-icons name="infos" class="cursor-pointer" type="button" (click)="openModalInfo()"></kz-icons>
    </div>
  </div>
    <app-flux-options-order
      *ngIf="showOptionOrder"
      [order]="requestOrder"
      (orderChanged)="requestOrder=$event"
      [disabled]="postLoading"
    ></app-flux-options-order>
   
  </div>
  
</ng-container>
<div class="kz-grid kz-grid--flux"
     [ngClass]="{'kz-grid--small': smallItem}"
     #kzGrid
     infinite-scroll
     [infiniteScrollDisabled]="infiniteScrollDisabled"
     [infiniteScrollDistance]="3"
     [infiniteScrollThrottle]="50"
     (scrolled)="onScroll()"
>
  <div class="kz-grid--flux-column"
       [ngStyle]="{'width' : (100/nbColumns) + '%', 'display' : ((platform == 'server') ? 'none' : 'inline-block') } "
       *ngFor='let dummy of numberReturn(nbColumns); let i= index'>
    <div class="grid-item"
         [ngClass]="{'grid-item--small': smallItem}"
         *ngFor="let p of splitPostArray(nbColumns, i + 1); let y = index; trackBy: trackPost;"
         [@entranceAnimation]="{ value : (p)? 'active' : null, params : {time : intranceTime + 'ms', delay : (((i + 1) + (y * nbColumns)) % itemsPerPage) * intranceDelay +'ms' }}"
         >
      <app-post-preview
        [post]="p"
        (removedPost)="removePost($event)"
        (favoriteRemoved)="requestType === 'favorites' && removePost($event)"
      ></app-post-preview>
    </div>
  </div>
</div>


<app-back-to-top></app-back-to-top>
<div class="center" *ngIf="postLoading || platform == 'server'">
  <kz-loader size="small"></kz-loader>
</div>

